import React from 'react'
import ChangePassword from '../forms/ChangePassword'
import NewDoctorForm from '../forms/NewDoctorForm'
import server from '../server'

const styles = {
    header:{
        margin:0,
        width:"100%",
        backgroundColor:"#2D83BB",
        padding:"20px 0px",
        color:"#FFFFFF",
        fontSize: 25,
        textAlign:"left",
    },

    overlay:{
        position:"fixed",
        top:0,
        width:"100%",
        left:0,
        height:"100%",
        backgroundColor:"rgba(0,0,0,0.5)",
        zIndex:"3000000"
    },

    header2:{
        margin:0,
        width:"100%",
        backgroundColor:"#FAFAFA",
        color:"#2D83BB",
        padding:"10px 0px",
        fontWeight:"bolder",
        fontSize: 15,
        textAlign:"left",
        marginBottom:10
    },

    modal:{
        position:"absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%,-50%)",
        backgroundColor:"#fafafa",
        zIndex:"4000000",
        padding:0
    },

    p:{
        margin:0,
        textAlign:"center",
        marginLeft: 10
    }
}

class FirstAccess extends React.Component{
    state = {
        page:0
    }

    complete = () =>{
        server.user.firstAccess = false;
        server.user.profilePicture = null;
        server.put("users/" + server.user.id, server.user, (data) =>{
                server.user = data;
                this.props.close();
        });
    }

    nextPage = () => {
        if(server.userType != "secretary"){
            this.complete();
        }else{
            this.setState({page:this.state.page + 1})
        }
    }

    render(){
        const pages = {
            0:<ChangePassword next={this.nextPage}/>,
            1:<NewDoctorForm close={this.complete}/>
        }
        const labels = {
            0:"Para começar por favor, cadastre uma nova senha e suas informações bancárias.",
            1:"Agora vamos cadastrar um médico."
        }
        return(
            <div>
                <div style={styles.overlay}></div>
                <div className="col-xs-12 col-md-5" style={styles.modal}>
                    <div style={styles.header}><p style={styles.p}>Bem vindo à Blues!</p></div>
                    <div style={styles.header2}><p style={styles.p}>{labels[this.state.page]}</p></div>
                    {pages[this.state.page]}
                </div>
            </div>
        )
    }
}

export default FirstAccess



// WEBPACK FOOTER //
// ./src/panels/FirstAccess.js